import gql from 'graphql-tag'

export const GET_PROMOCODES = gql`
query getPromocodes {
  promoCodes {
    nodes {
      id
      code
      endDate
      discountValue
      discountType
    }
  }
}

`

export default {
  GET_PROMOCODES
}
